// import { fstat } from 'original-fs'
import Vue from 'vue'
import Captcha from './main.vue'
import CaptchaManager from './Captcha.js'
const CaptchaConstructor = Vue.extend(Captcha)

let instance
let captchaResolve, captchaReject
const CaptchaBox = function (width, lang, sCallback, eCallback) {
  captchaResolve = sCallback
  captchaReject = eCallback
  showCaptchaBox(width, lang)
}

const showCaptchaBox = function (width, lang) {
  if (!instance) {
    initInstance()
  }
  if (!instance.visible) {
    document.body.appendChild(instance.$el)
    instance.width = width
    instance.init(lang)
    instance.visible = true
  }
}

const initInstance = () => {
  instance = new CaptchaConstructor({
    el: document.createElement('div')
  })
  instance.callback = defaultCallback
}

const defaultCallback = (action, msg) => {
  if (captchaResolve) {
    if (action === 'scuess') {
      captchaResolve(msg)
    } else if (action === 'err') {
      captchaReject(msg)
      instance.visible = false
    }
  }
}

CaptchaBox.show = (width, lang, sCallback, eCallback) => {
  return CaptchaBox(width, lang, sCallback, eCallback)
}
CaptchaBox.initCaptcha = () => {
  CaptchaManager.init()
}
export default CaptchaBox



// WEBPACK FOOTER //
// ./src/components/Captcha/src/main.js